<div *transloco="let t" class="relative bg-card dark:bg-transparent full-width">
  <!-- Loader -->
  <div class="absolute inset-x-0 top-0" *ngIf="isLoading">
    <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
  </div>
  <div mat-dialog-title>
    <span class="text-3xl sm:text-4xl">TOPUP NOW</span>
  </div>
  <div mat-dialog-content>
    <div class="flex flex-col flex-auto overflow-y-auto w-full">
      <div class="flex w-full items-center justify-around">
        <ng-container *ngIf="topupOptions?.length">
          <ng-container *ngFor="let option of topupOptions">
            <div
              (click)="selectThisOption(option)"
              class="flex h-20 w-30 items-center justify-center w-full border-2 border-black rounded-lg space-x-4 font-semibold text-4xl cursor-pointer hover:opacity-70 shadow-lg hover:shadow-sm"
            >
              <span>{{ option ?? 0 }}</span>
              <span>Dh</span>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="mt-4" mat-dialog-actions>
    <div
      class="flex w-full items-center justify-between"
      class="w-full sm:w-100"
    >
      <button
        mat-raised-button
        color="warn"
        type="button"
        (click)="closeDialog()"
      >
        {{ t("close") }}
      </button>
    </div>
  </div>
</div>
